var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPipedrive = function SvgPipedrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pipedrive_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#017737",
    d: "M18 0H6a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.121 4.679c-1.63 0-2.573.731-3.028 1.237-.054-.436-.342-1.001-1.463-1.001H6.196v2.548h.997c.17 0 .224.054.224.223v11.636h2.902v-4.368q0-.178-.006-.326c.454.416 1.32.99 2.672.99 2.836 0 4.82-2.25 4.82-5.47 0-3.271-1.884-5.47-4.684-5.47m-.59 8.41c-1.562 0-2.271-1.495-2.271-2.881 0-2.183 1.193-2.961 2.31-2.961 1.37 0 2.292 1.18 2.292 2.94 0 2.007-1.172 2.903-2.33 2.903",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pipedrive_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 6
  })))));
};
export default SvgPipedrive;